import { Directive, HostListener, Input } from '@angular/core';
import type { MmuMainMenuMainEntry } from '../main-menu/mmu-main-menu/mmu-main-menu.component';
import { MmuAnalyticsService } from './mmu-analytics.service';


@Directive({
  selector: '[mmuTrackMainMenuItem]'
})
export class MmuTrackMainMenuDirective {
  @Input()
  mmuTrackMainMenuItem?: MmuMainMenuMainEntry;

  constructor(private analyticsService: MmuAnalyticsService) {
  }

  @HostListener('click') onClick(): void {
    if (this.mmuTrackMainMenuItem) {
      if (this.mmuTrackMainMenuItem.tracked) {
        this.analyticsService.emitEvent('mainMenu', this.mmuTrackMainMenuItem.link, this.mmuTrackMainMenuItem.label);
      }
    } else {
      console.error('Analytics Service can\'t handle the click, some information is missing!');
      return;
    }
  }
}
